import { Widget } from "../widget";
import { any } from "./any";
import { stateful } from "./stateful";

/**
 * This widget waits until every of its sub-widgets have fired at least once.
 * When this condition is met, the `all` widget will start firing by propagating to its output the results of the widgets in an array
 * @deprecated No big point of using it at the moment
 * @param widgets A list of sub-widgets to watch.
 * @return An array of the current results of the widgets. The return results is always a full array (no element can be unset).
 */
export const all = function<o>(widgets:Widget<o>[]) : Widget<o[]> {
    return stateful<{left: number, v: o[]}>()(s =>
        any<[number,o]>()(
            widgets.map((w,i) => w.map(res => [i,res]))
        ).map(([i,res]) => {
            const newLeft = s.v[i]?s.left:s.left-1
            s.v[i]= res;
            return { left: newLeft
                   , v: s.v}
        })
    )({left: widgets.length, v: new Array(widgets.length)}).filter(x=>x.left<=0).map(x => x.v)
}

